import { rowPropsSchema } from '../component-catalog.js';
export const rowDefinition = {
    type: 'Row',
    category: 'layout',
    propsSchema: rowPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Horizontal CSS Grid container. Children fill their cell by default (charts fill remaining width; nested Row/Column size to content). To override column sizing, set `tracks` — one CSS Grid track value per child. Example: `tracks: ["2fr", "1fr", "200px"]` makes the first child twice as wide as the second, and the third exactly 200px. Other props: align?, justify?, gap? (number). For 2D tile layouts, nest Rows inside a Column.',
};
//# sourceMappingURL=Row.js.map